export default "__VITE_ASSET__fGQqoX9R__"